import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '@app/material.module';
import { SCModule } from '@symblcrowd/ng-symblcrowd';
import { Ng5SliderModule } from 'ng5-slider';
import { QuillModule } from 'ngx-quill';

@NgModule({
  imports: [
    FlexLayoutModule,
    MaterialModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    Ng5SliderModule,
    SCModule,
    QuillModule.forRoot()
  ],
  declarations: [
    //Pipes
    //Directives
  ],
  exports: [
    //Components
    SCModule
  ],
  providers: []
})
export class SCLocalModule {}
